<template>
    <div>
            <main-navigation />

  <div class="page-wrapper">
    <main class="container py-4">
      <div class="card shadow-lg border-0 rounded-4 p-4">
        <h4 class="mb-4 fw-bold page-title"><i class="bi bi-bank"></i> Create Paybill</h4>

        <!-- 🚀 FORM -->
        <form @submit.prevent="submitPaybill">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Business Short Code</label>
              <input
                v-model="form.BusinessShortCode"
                type="text"
                class="form-control"
                placeholder="Enter shortcode"
                required
              />
            </div>

            <div class="col-md-6">
              <label class="form-label">Type</label>
              <select v-model="form.type" class="form-control" required>
                <option value="">Select type</option>
                <option value="paybill">Safaricom Paybill</option>
                <option value="paybill">Bank Paybill</option>

                <option value="till">Safaricom Till</option>
              </select>
            </div>

            <div class="col-md-6">
              <label class="form-label">Account</label>
              <input
                v-model="form.account"
                type="text"
                class="form-control"
                placeholder="Leave blank if safaricom paybill"
                
              />
            </div>

            <div class="col-md-6">
              <label class="form-label">Name</label>
              <input
                v-model="form.name"
                type="text"
                class="form-control"
                placeholder="Enter name"
              />
            </div>
          </div>

          <!-- Submit -->
          <div class="mt-4 d-flex justify-content-end">
            <button class="btn btn-primary px-4" :disabled="loading">
              <span v-if="loading">Saving...</span>
              <span v-else>Create Paybill</span>
            </button>
          </div>
        </form>

        <!-- 📩 Message -->
        <div
          v-if="message"
          class="alert mt-4"
          :class="success ? 'alert-success' : 'alert-danger'"
        >
          {{ message }}
        </div>
      </div>
    </main>
  </div>
      </div>

</template>

<script>
import { apiFetch } from "@/services/api.js";

export default {
  name: "CreatePaybill",

  data() {
    return {
      loading: false,
      message: "",
      success: false,

      form: {
        BusinessShortCode: "",
        type: "",
        account: "",
        name: "",
      },
    };
  },

  methods: {
    // 🚀 Submit Paybill (MATCHES YOUR PATTERN)
    async submitPaybill() {
      this.loading = true;
      this.message = "";

      try {
        const data = await apiFetch("/create/paybill", {
          method: "POST",
          body: JSON.stringify({
            BusinessShortCode: this.form.BusinessShortCode.trim(),
            type: this.form.type.trim(),
            account: this.form.account.trim(),
            name: this.form.name.trim(),
          }),
        });

        this.success = true;
        this.message = data.message || "Paybill created successfully";

        // Reset form
        this.form.BusinessShortCode = "";
        this.form.type = "";
        this.form.account = "";
        this.form.name = "";
      } catch (error) {
        this.success = false;
        this.message = error.message || "Failed to create paybill";
      } finally {
        this.loading = false;
      }
          this.$router.push("/dashboard");

    },
  },
};
</script>

<style scoped>
.page-wrapper {
  background: var(--dash-bg);
  min-height: 100vh;
}

.card {
  max-width: 700px;
  margin: auto;
  border-radius: var(--dash-radius);
  border: 1px solid var(--dash-line);
  box-shadow: var(--dash-shadow-sm);
}

input,
select {
  border-radius: var(--dash-radius);
}

button {
  border-radius: var(--dash-pill);
}

/* Page title — matches the shared heading treatment in design.css */
.page-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: var(--dash-fs-h1);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--dash-ink);
}

.page-title i {
  font-size: 1.05em;
  color: var(--dash-primary);
}
</style>
